import React from 'react';
import classNames from 'classnames';
import {
  DueRow,
  ParseDueDate,
  formatDueDate,
  getFormName,
  getStatusTag,
} from './myProjectsMobile.utils';

export type CardSelection = {
  checked: boolean;
  disabled: boolean;
  onToggle: () => void;
};

type MyProjectsMobileCardProps = {
  row: DueRow;
  parseDueDate: ParseDueDate;
  now: Date;
  /** The row's action, built by InspectionsDue from the same handlers as the desktop row. */
  action: React.ReactNode;
  offlineActions?: React.ReactNode;
  /** Present only in select mode. */
  selection?: CardSelection;
};

/** SW2-2467. One My Projects row as a phone card. Presentational: no handlers of its own. */
const MyProjectsMobileCard: React.FC<MyProjectsMobileCardProps> = ({
  row,
  parseDueDate,
  now,
  action,
  offlineActions,
  selection,
}) => {
  const tag = getStatusTag(row, parseDueDate, now);
  const due = formatDueDate(row, parseDueDate);
  const site = row.siteName || '—';

  return (
    <article
      className={classNames(
        'my-projects-mobile__card',
        selection?.checked && 'my-projects-mobile__card--selected',
      )}
    >
      <div className='my-projects-mobile__card-top'>
        {selection && (
          <label className='my-projects-mobile__check'>
            <input
              type='checkbox'
              checked={selection.checked}
              disabled={selection.disabled}
              onChange={selection.onToggle}
            />
            <span className='my-projects-mobile__sr-only'>Select {site}</span>
          </label>
        )}
        <span className={`my-projects-mobile__tag my-projects-mobile__tag--${tag.tone}`}>
          {tag.label}
        </span>
        {due && (
          <span className='my-projects-mobile__due'>
            <span className='my-projects-mobile__sr-only'>Due </span>
            {due}
          </span>
        )}
      </div>

      <h3 className='my-projects-mobile__site'>{site}</h3>
      <p className='my-projects-mobile__meta'>{row.clientName || '—'}</p>
      <p className='my-projects-mobile__meta'>{getFormName(row)}</p>

      {action}

      {offlineActions && <div className='my-projects-mobile__offline'>{offlineActions}</div>}
    </article>
  );
};

export default MyProjectsMobileCard;
